import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Input from "../components/shared/input";
import Button from "../components/shared/button";
import { useNavigate } from "react-router-dom";
import { signUp } from "../APIs/userAuthApi";
import { useTranslation } from "react-i18next";
import { showErrorToast, showSuccessToast } from "../utils/helpers";
import { message } from "antd";

const Signup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Create as");
  console.log(selectedOption)
  const toggleDropdown = () => setIsOpen(!isOpen);

  const selectOption = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };
  // Define form validation schema with Yup
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  // Initialize formik with initial values, validation schema, and submit handler
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      role: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: (values) => {
      signUp(values.name, values.email, values.password, selectedOption)
        .then((res) => {
          showSuccessToast(res.message, 3000);
          navigate("/login");
        })
        .catch((err) => {
          showErrorToast(err, 3000);
        });
    },
  });

  return (
    <div className="flex flex-col lg:flex-row min-h-screen items-center max-md:gap-[60px] max-md:justify-start justify-center bg-lightwhite p-[20px]">
      {/* Left side */}
      <div className="max-md:min-h-[10vh] max-md:border-none min-h-[80vh] border-solid border-r-2 border-r-gray-200 flex flex-col items-center justify-center w-full md:w-1/2">
        <img
          src="../../assets/images/dashboard/logo_large.png"
          alt="logo"
          className="w-100 h-100 max-md:w-[60px] max-md:h-[60px]"
        />
        <p className="text-blue font-bold text-[34px] max-md:text-[18px]">
          {t("signup.leftSide.title")}
        </p>
      </div>

      {/* Right side */}
      <div className="flex flex-col items-center justify-center w-full md:w-1/2">
        <div className="w-full max-w-sm">
          <h4 className="small font-bold text-black">
            {t("signup.rightSide.title")}
          </h4>
          <p className="text-lightgray small leading-[15px]">
            {t("signup.rightSide.desc")}
          </p>

          {/* Formik form handler */}
          <form className="mt-[35px]" onSubmit={formik.handleSubmit}>
            <div className="flex flex-col gap-[18px]">
              {/* dropdown */}
              <div className="dropdown w-full relative">
                <div
                  className="dropdown-header h-[50px] flex justify-between items-center w-full px-4 py-3 rounded-lg bg-[#F0F0F0] cursor-pointer"
                  onClick={toggleDropdown}
                >
                  <div className="flex items-center gap-2">
                    <Icon
                      icon="mdi:user"
                      className="w-[18px] h-[18px]"
                      color="#717274"
                    />
                    <span className="text-[#8F8F8F] text-[13px] ">
                      {selectedOption}
                    </span>
                  </div>
                  <Icon
                    icon="ic:baseline-keyboard-arrow-down"
                    className="w-[18px] h-[22px]"
                    color="#717274"
                  />
                </div>
                {isOpen && (
                  <ul className="dropdown-options absolute top-full left-0 w-full bg-white rounded-lg shadow-lg mt-2 z-10">
                    <li
                      className="px-4 py-2 hover:bg-[#F0F0F0] cursor-pointer text-[#8F8F8F] text-[13px]"
                      onClick={() => selectOption("Lawyer")}
                    >
                      Lawyer
                    </li>
                    <li
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-[#8F8F8F] text-[13px]"
                      onClick={() => selectOption("Assistant")}
                    >
                      Assistant
                    </li>
                  </ul>
                )}
              </div>
              <Input
                type="text"
                name="name"
                placeholder={t("signup.rightSide.namePlaceholder")}
                leftImg="../../assets/icons/edit.png"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />
              {formik.touched.name && formik.errors.name && (
                <div className="text-red-500 text-xs">{formik.errors.name}</div>
              )}
              <Input
                type="email"
                name="email"
                placeholder={t("signup.rightSide.emailPlaceholder")}
                leftImg="../../assets/icons/Message.svg"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
              />
              {formik.touched.email && formik.errors.email && (
                <div className="text-red-500 text-xs">
                  {formik.errors.email}
                </div>
              )}
              <Input
                type="password"
                name="password"
                placeholder={t("signup.rightSide.passwordPlaceholder")}
                icon="mingcute:eye-2-fill"
                leftImg="../../assets/icons/Unlock.svg"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
              />
              {formik.touched.password && formik.errors.password && (
                <div className="text-red-500 text-xs">
                  {formik.errors.password}
                </div>
              )}
              <Input
                type="password"
                name="confirmPassword"
                placeholder={t("signup.rightSide.confirmPasswordPlaceholder")}
                icon="mingcute:eye-2-fill"
                leftImg="../../assets/icons/Unlock.svg"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirmPassword}
              />
              {formik.touched.confirmPassword &&
                formik.errors.confirmPassword && (
                  <div className="text-red-500 text-xs">
                    {formik.errors.confirmPassword}
                  </div>
                )}
            </div>

            <Button
              text={t("signup.rightSide.button")}
              type="submit"
              className="button btn-blue w-full mt-[38px]"
              height={50}
            />
          </form>
          <p className="small flex justify-center gap-[4px] m-auto mt-[8px]">
            {t("signup.rightSide.alreadyAccount")}
            <a href="/login" className="font-semibold">
              {t("signup.rightSide.login")}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Signup;
